import { SimpleLinkRenderer } from "widgets/commonComponents/inline/hyperLink"
import { SlotIconDisplay } from "widgets/commonComponents/inline/slotIconDisplay/slotIconDisplay"
import { PayWallArctilceIcon } from "widgets/commonComponents/inline/payWallHavak/payWallHavak"
import { separateHourFromDateAndFormatToString } from "widgets/widgetsUtils"
import { isWcmEditor } from "config/serverConfig"
import { MultiImagesMainAutoArticleItem, MultiImagesMainAutoFieldsProps, CAROUSEL_IMAGE_WIDTH, CAROUSEL_IMAGE_HEIGHT } from "./multiImagesMainAutoTypes"

interface MultiImagesMainAutoCarouselItemProps extends MultiImagesMainAutoFieldsProps {
    item: MultiImagesMainAutoArticleItem
    index: number
}

export const MultiImagesMainAutoCarouselItem = (props: MultiImagesMainAutoCarouselItemProps) => {

    const { item, index, fieldsDisplaySettings, titleColor, labelColor, labelBackgroundColor } = props
    const { itemId, title, author, titleLink, dateUpdatedOnSite, displayVideoIcon, premiumExpireDays, categoryName, imageUrl, imageAlt, imageTitle } = item

    const href = isWcmEditor() ? "" : titleLink
    const showCategory = fieldsDisplaySettings.isCategoryVisible && !!categoryName
    const showAuthor = fieldsDisplaySettings.isAuthorVisible && author && author.length > 0
    const showDate = fieldsDisplaySettings.isDateVisible
    const showHour = fieldsDisplaySettings.isHourVisible
    const showMeta = showAuthor || showDate || showHour

    const dateText = (showDate || showHour)
        ? separateHourFromDateAndFormatToString(dateUpdatedOnSite, {
            showDate,
            showHour,
            dateTimeSeperator: "  |  ",
            isDateFirst: true,
        })
        : ""

    return (
        <div className={`slotView ${isWcmEditor() ? "inEditMode" : ""}`} key={`carouselItem_${itemId}_${index}`}>
            <div className="imageArea" data-tb-thumbnail="">
                <PayWallArctilceIcon className="onImage" premiumExpireDays={premiumExpireDays} dateUpdatedOnSite={dateUpdatedOnSite} />

                <SlotIconDisplay itemId={itemId} iconClassName="medium" isIconVisible={displayVideoIcon} icon={displayVideoIcon ? "video" : "none"} />

                <SimpleLinkRenderer href={href} className="mediaLink">
                    <img
                        src={imageUrl}
                        alt={imageAlt}
                        title={imageTitle}
                        width={CAROUSEL_IMAGE_WIDTH}
                        height={CAROUSEL_IMAGE_HEIGHT}
                    />
                </SimpleLinkRenderer>
            </div>

            <div className="slotTextArea">
                {showCategory && <div className="categoryTag" style={{ color: labelColor, backgroundColor: labelBackgroundColor }} data-tb-category>{categoryName}</div>}

                <SimpleLinkRenderer href={href} className="slotTitleLink">
                    <h3 className="slotTitle" style={{ color: titleColor }}>{title}</h3>
                </SimpleLinkRenderer>

                {showMeta &&
                    <div className="moreDetails">
                        {showAuthor && <span className="authorField" data-tb-author>{author}</span>}
                        {showAuthor && dateText && <span className="separator"> | </span>}
                        {dateText && <span className="dateField" data-tb-date>{dateText}</span>}
                    </div>
                }
            </div>
        </div>
    )
}
